<ng-container *ngTemplateOutlet="mode() === 'home' ? homefilter : nohomefilter"></ng-container>
<ng-template #homefilter>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @case ('md') {
    <ng-container *ngTemplateOutlet="homemodeMobile"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="homefilterdesk"></ng-container>
    }
    }
</ng-template>

<ng-template #nohomefilter>
    @if(mode()==='nohomesmall' ) { {{zielText()}} } @else { <ng-container *ngTemplateOutlet="homemodeMobile">
    </ng-container>
    }
</ng-template>
<!-- <ng-template #mbfilters>
    <button class="tmpbtn w100" [class.tmpnorightborder]="tmpnorightborder" [class.bottomleftradius]="bottomleftradius"
        [class.bottomrightradius]="bottomrightradius" [class.toprightradius]="toprightradius"
        [class.topleftradius]="topleftradius" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <ng-container *ngTemplateOutlet="iconn"></ng-container>
        <span class="ellipsis">{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template>
</ng-template> -->


<ng-template #homemodeMobile>
    <div class="searchBoxWrapper_mobile customflex" #mdbuttondesk="cdkOverlayOrigin"
        [class.searchBoxWrapperactive]="showModal()" cdkOverlayOrigin (click)="openModal()" ng-clickOutside
        (clickOutside)="closeModal()">
        <div class="wrapper flx">
            <span class="description">{{title}}</span>
            <span class="ellipsis">{{zielText()}}</span>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
            [cdkConnectedOverlayPositions]="overlaypos" [cdkConnectedOverlayOpen]="showModal()"
            [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeModal()">
            <ng-container *ngTemplateOutlet="modal"></ng-container>
        </ng-template>
    </div>
    <!-- <button class="tmpbtn w100" [class.tmpnorightborder]="tmpnorightborder" [class.bottomleftradius]="bottomleftradius"
        [class.bottomrightradius]="bottomrightradius" [class.toprightradius]="toprightradius"
        [class.topleftradius]="topleftradius" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile($event)" matRipple>
        <ng-container *ngTemplateOutlet="iconn"></ng-container>
        <span class="ellipsis">{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template> -->
</ng-template>

<ng-template #homefilterdesk>
    <!-- <button class="tmpbtn w100" [class.tmpnorightborder]="tmpnorightborder" [class.bottomleftradius]="bottomleftradius"
        [class.bottomrightradius]="bottomrightradius" [class.toprightradius]="toprightradius"
        [class.topleftradius]="topleftradius" #mdbuttondesk="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModal($event)" matRipple>
        <ng-container *ngTemplateOutlet="iconn"></ng-container>
        <span>{{zielText}}</span>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModal()">
        <ng-container *ngTemplateOutlet="modal"></ng-container>
    </ng-template> -->

    <div class="searchBoxWrapper bigger" #mdbuttondesk="cdkOverlayOrigin" [class.searchBoxWrapperactive]="showModal()"
        cdkOverlayOrigin (click)="openModal()" ng-clickOutside (clickOutside)="closeModal()">
        <div class="wrapper flx">
            <span class="description">{{title}}</span>
            <span class="ellipsis">{{zielText()}}</span>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttondesk"
            [cdkConnectedOverlayPositions]="overlaypos" [cdkConnectedOverlayOpen]="showModal()"
            [cdkConnectedOverlayHasBackdrop]="false" (backdropClick)="closeModal()">
            <ng-container *ngTemplateOutlet="modal"></ng-container>
        </ng-template>
    </div>
</ng-template>


<ng-template #modal>
    @switch (mediaService.media()) {
    @case ('xs') {
    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
    }
    @case ('sm') {
    <ng-container *ngTemplateOutlet="mobileModal"></ng-container>
    }
    @default {
    <ng-container *ngTemplateOutlet="mobileDesk"></ng-container>
    }
    }
</ng-template>


<ng-template #mobileDesk>
    <!-- <div class="backdropwrapper mat-elevation-z1" [@zoom]="origin">
        <div class="filterwrapper">
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div> -->
    <div class="custompopupwrapper mat-elevation-z1">
        <div class="popupbody">
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #mobileModal>
    <div class="custompopupwrapper-mobile">
        <div class="popupbody">
            <ng-container *ngTemplateOutlet="datassection"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #datassection>
    <!-- <div class="f-bodywrapper customscroll" [class.f-bodywrapper-mobile]="media === 'xs' || media=== 'sm'">
        <button class="item-wrapper" (click)="selectValue(null)" *ngIf="beliebig">
            <div class="item-body">
                <span class="first-item-line">beliebig</span>
            </div>
        </button>
        <ng-container *ngFor="let item of list">
            <button class="item-wrapper" (click)="selectValue(item)">
                <div class="item-body">
                    <span class="first-item-line">{{item.name}}</span>
                </div>
            </button>
        </ng-container>
    </div> -->
    <div class="resultatwrapper customscroll" (click)="$event.stopPropagation()">
        @for (item of list; track $index) {
        <div class="item-body" (click)="selectValue(item)">
            <span class="first-item-line">{{item.name}}</span>
        </div>
        }
    </div>
</ng-template>


<ng-template #iconn>
    <ng-container [ngSwitch]="icon">
        <ng-container *ngSwitchCase="'directions_boat'" [ngTemplateOutlet]="directions_boat1"></ng-container>
        <ng-container *ngSwitchCase="'verified'" [ngTemplateOutlet]="verified1"></ng-container>
        <ng-container *ngSwitchCase="'place'" [ngTemplateOutlet]="place1"></ng-container>
        <ng-container *ngSwitchCase="'timelapse'" [ngTemplateOutlet]="timelapse1"></ng-container>
        <ng-container *ngSwitchCase="'people_alt'" [ngTemplateOutlet]="people_alt1"></ng-container>
        <ng-container *ngSwitchCase="'flight'" [ngTemplateOutlet]="flight1"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="houseboat1"></ng-container>
    </ng-container>
</ng-template>

<ng-template #flight1>
    <mat-icon fontIcon="flight"></mat-icon>
</ng-template>

<ng-template #people_alt1>
    <mat-icon fontIcon="people_alt"></mat-icon>
</ng-template>

<ng-template #directions_boat1>
    <mat-icon fontIcon="directions_boat"></mat-icon>
</ng-template>

<ng-template #verified1>
    <mat-icon fontIcon="verified"></mat-icon>
</ng-template>

<ng-template #place1>
    <mat-icon fontIcon="place"></mat-icon>
</ng-template>

<ng-template #timelapse1>
    <mat-icon fontIcon="timelapse"></mat-icon>
</ng-template>

<ng-template #houseboat1>
    <mat-icon fontIcon="houseboat"></mat-icon>
</ng-template>